<div class="container d-none d-lg-block">
  <div class="row">
    <div class="col-12">
      <div class="card card-chart h-100 p-3">
        <div class="card-header card-header-icon">
          <div class="card-icon shadow {{ iconContainerClass }}">
            <i class="{{ iconClass }}"></i>
          </div>
          <h4 class="card-title">{{ titulo }}</h4>
        </div>
        <div class="card-body">
          @if (estado === ESTADO.OK) {
          <div>
            <div class="chart" style="display: block">
              <canvas
                baseChart
                width="600"
                height="300"
                [data]="lineChartData"
                [options]="lineChartOptions"
                [type]="lineChartType"
                [plugins]="lineChartPlugins"
              ></canvas>
            </div>
          </div>
          } @if (estado === ESTADO.BUSCANDO) {
          <div
            class="row flex-column justify-content-center align-content-center"
          >
            <div class="text-center">
              <i class="fas fa-spinner fa-2x fa-spin fa-fw"></i>
            </div>
            <div class="mt-1">Cargando</div>
          </div>
          } @if (estado === ESTADO.ERROR) {
          <div class="card p-20 col-12 col-lg-6">
            <h5>Oops... Ocurrió un error al traer la información.</h5>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container d-block d-lg-none">
  <div class="row">
    <div class="col-12">
      <div class="card card-chart h-100 p-3">
        <div class="card-header card-header-icon">
          <div class="card-icon shadow {{ iconContainerClass }}">
            <i class="{{ iconClass }}"></i>
          </div>
          <h4 class="card-title">{{ titulo }}</h4>
        </div>
        <div class="card-body">
          @if (estado === ESTADO.OK) {
          <div>
            <div class="chart" style="display: block">
              <canvas
                baseChart
                width="100%"
                height="auto"
                [data]="lineChartData"
                [options]="lineChartOptions"
                [type]="lineChartType"
                [plugins]="lineChartPlugins"
              ></canvas>
            </div>
          </div>
          } @if (estado === ESTADO.BUSCANDO) {
          <div
            class="row flex-column justify-content-center align-content-center"
          >
            <div class="text-center">
              <i class="fas fa-spinner fa-2x fa-spin fa-fw"></i>
            </div>
            <div class="mt-1">Cargando</div>
          </div>
          } @if (estado === ESTADO.ERROR) {
          <div class="card p-20 col">
            <h5>Oops... Ocurrió un error al traer la información.</h5>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
